<template>
  <b-container class="mt-4 mb-4 text-center">
    <b-card class="cardStyle">
      <b-card-title>{{ title }}</b-card-title>
      <div>
        <p>
          <slot name="description" />
        </p>

        <slot v-if="hasIconSlot" name="icon" />
        <b-icon v-else class="h2 mb-0" icon="check-circle-fill" variant="success"></b-icon>

        <section v-if="!hasDescriptionSlot">
          <p class="thank-you-text-style my-3">Thank you!</p>
          <p>
            If you would like to submit another access request, please refer back to the link in
            your email. This link is valid for 12 hours.
          </p>
        </section>
      </div>
    </b-card>
  </b-container>
</template>

<script>
  export default {
    name: 'thank-you',
    props: {
      title: { type: String, default: 'Your request has been received' },
    },
    computed: {
      hasDescriptionSlot() {
        return !!this.$slots.description;
      },
      hasIconSlot() {
        return !!this.$slots.icon;
      },
    },
  };
</script>

<style scoped>
  .thank-you-text-style {
    font-size: 20px;
    line-height: 28px;
    color: #383838;
  }
</style>
